import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { BrokerOfficeDetailsResponse } from '@/entity/BrokerOffice';
import { GET_BROKER_OFFICE_DETAILS } from '@/constants';

export const useGetBrokerOfficeDetailsBySlug = (
  slug?: string | null,
  options?: Partial<UseQueryOptions<BrokerOfficeDetailsResponse, AxiosError>>,
) => {
  return useQuery<BrokerOfficeDetailsResponse, AxiosError>({
    queryKey: ['broker-office-details-slug', slug],
    queryFn: () =>
      axios
        .get<BrokerOfficeDetailsResponse>(`${GET_BROKER_OFFICE_DETAILS}/${slug}`)
        .then((res) => res.data),
    staleTime: 0,
    gcTime: 0,
    enabled: Boolean(slug),
    ...options,
  });
};
